import { ISignInState } from '@telstra-connect/login/state';
import { Config } from '@telstra-connect/config/config';
import { Platform } from '@telstra-connect/config/platform';
import { generateUUID4 } from '@telstra-connect/utils/data/random';
import global from '@applications/index';
import { ContentTypes, HttpHeaders, PlrTransactionIdType, PLRPathList } from '../constants';
import { isEDN } from '@telstra-connect/config/auth-config';

type UserAgnosticKeys
    = 'vendor-id'
    | 'app-version'
    | 'device-os'
    | 'device-type'
    | 'request-id'
    | 'session-id';

type UserSpecificKeys
    = 'Authorization'
    | 'company-id'
    | 'plr-transaction-id'
    | UserAgnosticKeys;

type UnionKeyToValue<U extends string, V> = {
    [K in U]: V
};

const getToken = (state: ISignInState) => {
    if (!state ||
        !state.user ||
        !state.user.oauth ||
        !state.user.oauth.token ||
        !state.user.oauth.token.accessToken) {
        return undefined;
    }
    return state.user.oauth.token.accessToken;
};

const getNonDefaultCompanyId = (state) => {
    try {
        return state.userManagement.preferences.data.lastSelectedCompanies[0].cidn;
    } catch {
        return undefined;
    }
};

const getPLRHeader = (state) => {
    try {
        const page = PLRPathList.indexOf(window.location.pathname);
        return PlrTransactionIdType[page]
    } catch (error) {
        return undefined
    }
}

export const getUserAgnosticHeaders = () => {
    const sessionDetails = global.TCONN.getSessionDetails && global.TCONN.getSessionDetails();
    const UUIDString = (generateUUID4()).substring(0, 20);
    return Object.freeze<UnionKeyToValue<UserAgnosticKeys, string>>({
        'vendor-id': Config.application.vendorId,
        'app-version': Config.application.version,
        ...(!Platform.isDesktop) && { 'device-os': Platform.formatter.deviceOs },
        'device-type': Platform.formatter.deviceType,
        'request-id': `REQ-${UUIDString}`,
        'session-id': `TCN-${sessionDetails && sessionDetails.sessionId}`
    });
};
export const checkIfStaffUser = (state) => {
    try {
        return state.tokens.customerProfile.data.profile === 'staff_user'
    } catch (error) {
        return undefined
    }
}
export const getUserSpecificHeaders = (state: ISignInState) => {
    const token = getToken(state);

    if (!token) {
        return null;
    }

    const companyId = getNonDefaultCompanyId(state);
    const userAgnosticHeaders = getUserAgnosticHeaders();
    const PLRHeader = getPLRHeader(state);
    const isStaffUser = checkIfStaffUser(state);

    return Object.freeze<UnionKeyToValue<UserSpecificKeys, string>>({
        ...userAgnosticHeaders,
        Authorization: `Bearer ${token}`,
        ...companyId && { 'company-id': companyId },
        ...(isStaffUser && PLRHeader) && { 'plr-transaction-id': PLRHeader }
    });
};

export const getBaseHeaders = (contentType?: ContentTypes) => {
    const isSecureAuth = global.TCONN?.Platform?.isSecureAuth || false;
    return {
        Accept: ContentTypes.JSON,
        userType: (isEDN && isSecureAuth) ? 'staff' : 'customer',
        ...contentType && { [HttpHeaders.ContentType]: contentType }
    };
};
